import { MessageCircle, Truck, Headphones } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";
import { supportWhatsappUrl, whatsappConfigured } from "@/context/CartContext";

export default function Shipping() {
  const { t } = useLanguage();
  const waOn = whatsappConfigured();
  return (
    <section data-testid="shipping-section" className="bg-[#f7f7f5] py-20 lg:py-24">
      <div className="mx-auto max-w-4xl px-5 text-center lg:px-10">
        <Reveal>
          <Truck className="mx-auto h-7 w-7 text-[#111]" strokeWidth={1.3} />
          <h2 className="mt-4 font-serif-display text-3xl font-medium text-[#111] sm:text-4xl">{t.shipping.title}</h2>
          <p className="mx-auto mt-4 max-w-xl font-body text-sm leading-relaxed text-[#666]">{t.shipping.text}</p>
        </Reveal>
        <Reveal delay={0.1} className="mt-10">
          <div className="mx-auto flex max-w-md flex-col items-center gap-3 rounded-2xl border border-[#eee] bg-white p-8">
            <Headphones className="h-6 w-6 text-[#111]" strokeWidth={1.3} />
            <h3 className="font-body text-base font-medium text-[#111]">{t.shipping.supportTitle}</h3>
            {waOn && (
              <a
                data-testid="shipping-whatsapp"
                href={supportWhatsappUrl(t)}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-1 inline-flex items-center gap-2 rounded-full bg-[#111] px-6 py-3 font-body text-sm font-medium text-white transition-colors duration-200 hover:bg-[#2a2a2a]"
              >
                <MessageCircle className="h-4 w-4" /> {t.shipping.contact}
              </a>
            )}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
